import { GetB2bCampaignsPayoutsOneResponse } from '@Common/types/b2b/campaigns';
import {
  GetB2bCampaignAllocationOneResponse,
  GetB2bCampaignOneResponse,
} from '@Common/types/bo/b2b/campaigns';

export const campaignsTranslations = {
  'campaigns/payouts': {
    fields: {
      id: 'ID',
      b2b_campaign_id: 'Campaign ID',
      b2b_company_id: 'Company ID',
      b2b_employee_id: 'Employee ID',
      lastname: 'Last name',
      firstname: 'First name',
      savings_funds_request_id: 'Savings funds request ID',
      created_at: 'Created at',
      updated_at: 'Updated at',
      user_currency_amount: 'Net amount',
      total_gross_amount: 'Gross amount',
      user_currency: 'Currency',
      tax_amount: 'Tax amount',
      tax_info: 'Tax info',
      status: 'Status',
      payout_by: 'Payout by',
      transfer_id: 'Transfer ID',
      transfer_mdlr_status: 'Transfer status',
      transfer_amount: 'Transfer amount',
      transfer_created_at: 'Transfer created at',
      transfer_executed_at: 'Transfer executed at',
    } satisfies Record<keyof GetB2bCampaignsPayoutsOneResponse, string>,
    sections: { title: 'Payout' },
  },
  campaigns: {
    fields: {
      id: 'Operation ID',
      company_id: 'Company ID',
      products: 'Product coverage',
      b2b_contract_ids: 'Contract IDs',
      b2b_contract_types: 'Contract Types',
      type: 'Type',
      start_date: 'Consultation start date',
      end_date: 'Consultation end date',
      from_created_at: 'From created at',
      to_created_at: 'To created at',
      employees_count: 'Number of eligible employees',
      total_campaign_amount_gross: 'Total operation amount gross',
      total_campaign_amount_net: 'Total operation amount net of CSG/CRDS',
      total_entry_fee_amount: 'Total entry fees',
      total_net_invested_amount: 'Total net invested amount',
      total_net_amount: 'Total amount to be paid net',
      total_gross_amount: 'Total amount to be paid gross',
      status: 'Status',
      savings_funds_request_id: 'Savings funds request ID',
      created_at: 'Created at',
      updated_at: 'Updated at',
      payment_method: 'Payment method',
      matching_contribution_related_cash_source: 'Source de versement associée',
      matching_contribution_related_cash_source_input: 'Source de versement associée',
      related_campaign_id: 'Related campaign',
      choice_collected_by: 'Choices collected by',
      matching_contribution_computed_by: 'Matching contribution computed by',
      payout_by: 'Payouts by',
      allocation_computed_by: 'Allocations computed by',
      fiscal_period_start: 'Fiscal period start date',
      fiscal_period_end: 'Fiscal period end date',
      reason: 'Reason',
      reference_year: 'Reference year',
      amount_type_input: 'Amount type input',
      value_sharing_bonus_fiscal_rule: 'Value Sharing Bonus Fiscal Rule',
      is_draft: 'Is Draft',
      is_cancelled: 'Is Cancelled',
      amount_input: 'Amount input',
      is_late_payment_interests: 'Has late payment interests',
      is_emails_enabled: 'Campaign emails enabled',
      distribution_rule_file_url: 'Distribution rule file',
      allocation_file_url: 'Allocations file',
      late_payment_interests_override_amount: 'Late payment interests override amount',
      total_matching_contribution_amount: 'Total matching contribution amount to be paid',
      total_matching_contribution_amount_gross: 'Total matching contribution amount gross',
      total_matching_contribution_entry_fee_amount: 'Total matching contribution entry fees',
      total_matching_contribution_net_invested_amount:
        'Total matching contribution net invested amount',
      reference_period: 'Reference period',
      target_fund_request_date: 'Funds request date',
      target_nav_date: 'NAV date',
      target_payment_date: 'Payment date (SEPA DD or Bank transfer)',
      group_operation_gross_amount: 'Group operation gross amount',
    } satisfies Record<keyof GetB2bCampaignOneResponse & 'reference_period', string>,
  },
  'campaigns/allocations': {
    fields: {
      id: 'Allocation ID',
      campaign_id: 'Operation ID',
      employee_id: 'Employee ID',
      firstname: 'First name',
      lastname: 'Last name',
      identifier: 'Identifier',
      registration_number: 'Registration number',
      net_amount: 'Net of CSG/CRDS amount',
      net_amount_deposit: 'Deposit net amount',
      gross_amount: 'Gross amount',
      entry_fee_amount: 'Entry fees',
      net_invested_amount: 'Net invested amount',
      invested_amount: 'Invested amount (net of CSG/CRDS)',
      matching_contribution_amount: 'Matching contribution amount (gross)',
      payout_amount: 'Pay out amount',
      late_interests_amount: 'Late interests amount (gross)',
      amount_in_days: 'Total days',
      cet_days: 'Miscellaneous days',
      rtt_days: 'RTT days',
      overtime_days: 'Overtime days',
      paid_leave_days: 'Paid leave days',
      seniority_leave_days: 'Seniority leave days',
      untaken_rest_days: 'Untaken rest days',
      invested_amount_in_days: 'Invested days',
      invested_cet_days: 'Invested miscellaneous days',
      invested_rtt_days: 'Invested RTT days',
      invested_overtime_days: 'Invested overtime days',
      invested_paid_leave_days: 'Invested paid leave days',
      invested_seniority_leave_days: 'Invested seniority leave days',
      invested_untaken_rest_days: 'Invested untaken rest days',
      csg_amount: 'CSG amount',
      crds_amount: 'CRDS amount',
      company_id: 'Company ID',
      social_status: 'Social status',
      tax_residence_code: 'Tax residence code',
      company_collected_choices: 'Company collected choices',
    } satisfies Record<keyof GetB2bCampaignAllocationOneResponse & 'net_amount_deposit', string>,
    label: 'Breakdown per eligible employee',
  },
  'campaigns/employees_awaiting_response': {
    fields: {
      id: 'Employee ID',
      firstname: 'First name',
      lastname: 'Last name',
    },
    label: 'Employees who have not made a choice yet',
  },
};
